
import { Component, Prop, Vue } from 'vue-property-decorator';
import SingleImageUpload from '@/components/SingleImageUpload/index.vue';
import BindChargeLevel from '@/components/Recharge/level.vue';

@Component({
  components: { SingleImageUpload, BindChargeLevel },
})
export default class extends Vue {
  @Prop() model: any;
  @Prop() keyIndex: any;
  @Prop() descModel: any;
  route = 'route';
  stateModel = [
    {
      value: 'route',
      lable: 'APP内部',
    },
    {
      value: 'link',
      lable: '跳转连接',
    },
    {
      value: 'csj',
      lable: '穿山甲',
    },
  ];
  bannerSizeOptions = [
    { value: '', label: '请选择尺寸' },
    { value: '600x300', label: '600*300px' },
    { value: '600x400', label: '600*400px' },
    { value: '600x500', label: '600*600px' },
    { value: '600x260', label: '600*260px' },
    { value: '600x90', label: '600*90px' },
    { value: '600x150', label: '600*150px' },
    { value: '640x100', label: '640*100px' },
    { value: '690x388', label: '690*388px' },
  ];
  appModel = [
    {
      value: 'coin',
      lable: '云币充值',
    },
    {
      value: 'card',
      lable: '周期卡充值',
    },
    {
      value: '/promoter',
      lable: '推广员',
    },
    {
      value: '/share',
      lable: '领云币',
    },
    {
      value: '/wellness_centers',
      lable: '领福利',
    },
    {
      value: '-1',
      lable: '请选择',
    },
  ];
  appModelChange() {
    // console.log('收到AppID变化: ', this.model.appid);
    if (this.model.appid === 'coin') {
      this.$emit('changeGradeType', 1, this.keyIndex);
    } else if (this.model.appid === 'card') {
      this.$emit('changeGradeType', 2, this.keyIndex);
    } else {
      this.$emit('changeGradeType', -1, this.keyIndex);
    }
  }
  deleteForm() {
    //this.$emit('deleteForm');
    this.$emit('delete', this.keyIndex);
  }
}
